import { useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import { NumericFormat, NumberFormatValues } from 'react-number-format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { hooks as commonHooks } from '@sitebuilder/common';

interface PropsShape {
    id: string;
    value: number;
    defaultValue: number;
    onChange: (v: NumberFormatValues, id: string) => void;
    onIncrement: (id: string) => void;
    onDecrement: (id: string) => void;
}

const NumberInput = (props: PropsShape) => {
    const i18n = commonHooks.useLocalization();

    return (
        <div className="inches-input-group">
            <NumericFormat
                /* @ts-ignore */
                className="number-input"
                defaultValue={props.defaultValue}
                value={props.value}
                suffix={'in'}
                decimalSeparator="."
                type="text"
                thousandSeparator={false}
                allowNegative={true}
                onValueChange={(values) => props.onChange(values, props.id)}
            />
            <div className="icon-group">
                <FontAwesomeIcon
                    className={'icon increment-icon'}
                    icon={faChevronUp}
                    onClick={() => props.onIncrement(props.id)}
                    title={i18n.t('customSchemaWidgets_increment')}
                />
                <FontAwesomeIcon
                    className={'icon decrement-icon'}
                    icon={faChevronDown}
                    onClick={() => props.onDecrement(props.id)}
                    title={i18n.t('customSchemaWidgets_decrement')}
                />
            </div>
        </div>
    );
};

const PdfMarginField = (props: WidgetProps) => {
    const { schema, onChange } = props;
    const [formData, setFormData] = useState(props.formData);

    const handleChange = (values: NumberFormatValues, id: string) => {
        setFormData({ ...formData, [id]: values.floatValue });
        onChange({ ...formData, [id]: values.floatValue });
    };

    const handleIncrement = (id: string) => {
        setFormData({ ...formData, [id]: parseFloat((formData[id] + 0.01).toFixed(2)) });
        onChange({ ...formData, [id]: parseFloat((formData[id] + 0.01).toFixed(2)) });
    };

    const handleDecrement = (id: string) => {
        setFormData({ ...formData, [id]: parseFloat((formData[id] - 0.01).toFixed(2)) });
        onChange({ ...formData, [id]: parseFloat((formData[id] - 0.01).toFixed(2)) });
    };

    const properties = schema.properties && Object.values(schema.properties);
    const propertyKeys = schema.properties && Object.keys(schema.properties);

    return (
        <div className="pdf-margin-field">
            <label>{props.schema.title}</label>
            <div className="margin-widget">
                {properties?.length &&
                    propertyKeys?.length &&
                    properties.map((p: any, i: number) => {
                        const key = propertyKeys[i];
                        return (
                            <div className={'margin-input'} key={`${p}-${i}`}>
                                <label>{p.title}</label>
                                <NumberInput
                                    id={key || 'id'}
                                    defaultValue={p.default}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    onIncrement={handleIncrement}
                                    onDecrement={handleDecrement}
                                />
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default PdfMarginField;
